import { render, staticRenderFns } from "./OneDayAddV4.vue?vue&type=template&id=45110199&"
import script from "./OneDayAddV4.vue?vue&type=script&lang=ts&"
export * from "./OneDayAddV4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports